import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuardService, GuardAdministratorRoutes, PermissionRouteGuard} from './guards/auth-guard.service'
export const AppRoutes: Routes = [{
        path: '',
        redirectTo: '/pages/login',
        pathMatch: 'full',
      }, {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AuthGuardService],
        children: [{
            path: '',
            loadChildren: './dashboard/dashboard.module#DashboardModule'
        }, {
            path: '',
            loadChildren: './politica-representantes/politica-representantes.module#PoliticaRepresentantesModule'
        }, {
            path: '',
            loadChildren: './components/components.module#ComponentsModule'
        }, {
            path: '',
            loadChildren: './forms/forms.module#Forms'
        }, {
            path: 'tables',
            loadChildren: './tables/tables.module#TablesModule'
        }, {
            path: 'maps',
            loadChildren: './maps/maps.module#MapsModule'
        }, {
            path: 'charts',
            loadChildren: './charts/charts.module#ChartsModule'
        }, {
            path: 'calendar',
            loadChildren: './calendar/calendar.module#CalendarModule'
        }, {
            path: '',
            loadChildren: './userpage/user.module#UserModule'
        }, {
            path: '',
            loadChildren: './timeline/timeline.module#TimelineModule'
        }, {
            path: '',
            loadChildren: './widgets/widgets.module#WidgetsModule'
        }, {
            path: '',
            loadChildren: './simulations/simulations.module#SimulationsModule'
        }, {
            path: '',
            loadChildren: './order/order.module#OrderModule'
        }, {
            path: '',
            loadChildren: './invoice/invoice.module#InvoiceModule'
        }, {
            path: '',
            loadChildren: './negotiation-trade/negotiation.module#NegotiationModule'
        }, {
            path: '',
            loadChildren: './negotiation/negotiation.module#NegotiationModule'
        }, {
            path: '',
            // canActivate: [GuardAdministratorRoutes],
            loadChildren: './customer/customer.module#CustomerModule'
        }, {
            path: '',
            // canActivate: [GuardAdministratorRoutes],
            loadChildren: './purchase/purchase.module#PurchaseModule'
        }, {
            path: '',
            canActivate: [GuardAdministratorRoutes],
            loadChildren: './pre-invoice/pre-invoice.module#PreInvoiceModule'
        },
        {
            path: '',
            loadChildren: './user/user.module#UserModule'
        },]
        }, {
            path: '',
            component: AuthLayoutComponent,
            children: [{
                path: 'pages',
                loadChildren: './pages/pages.module#PagesModule'
            }]
        }
];
